// Uploads a resume immediately and triggers server-side parsing + autofill.
import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["input"];
  static values = { parseUrl: String };

  upload(event) {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("resume", file);

    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch(this.parseUrlValue, {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token
      },
      body: formData
    })
      .then((response) => {
        if (!response.ok) throw new Error("Upload failed");
        return response.text();
      })
      .then((html) => Turbo.renderStreamMessage(html))
      .catch(() => {
        const container = document.getElementById("resume-parse-result");
        if (container) {
          container.innerHTML =
            '<p class="mt-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">Could not upload resume. Please try again.</p>';
        }
      });
  }
}
